import { render, staticRenderFns } from "./uploadImginbatch.vue?vue&type=template&id=6449121c&scoped=true"
import script from "./uploadImginbatch.vue?vue&type=script&lang=js"
export * from "./uploadImginbatch.vue?vue&type=script&lang=js"
import style0 from "./uploadImginbatch.vue?vue&type=style&index=0&id=6449121c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6449121c",
  null
  
)

export default component.exports